export default "__VITE_PUBLIC_ASSET__17770373__"